import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { businessApi } from '~/entities/business/api/business'
import { getErrorMessageFromError } from '~/shared/lib/api-errors'
import { QueryKey, queryKey } from '~/shared/lib/query-keys'
import { storageManager } from '~/shared/lib/storage-manager'
import { MINUTES } from '~/shared/lib/time-constants'

/** Whether the signed-in team member gets the e-mails about their events; off for admins viewing. */
export function useEventEmails() {
  return useQuery({
    queryKey: queryKey(QueryKey.AUTH_EVENT_EMAILS),
    queryFn: () => businessApi.getEventEmails(),
    enabled: !storageManager.isAdmin(),
    staleTime: 5 * MINUTES,
    retry: false,
  })
}

export function useSetEventEmails() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (enabled: boolean) => businessApi.setEventEmails(enabled),
    onSuccess: (data) => {
      queryClient.setQueryData(queryKey(QueryKey.AUTH_EVENT_EMAILS), data)
    },
    onError: (error: unknown) => {
      toast.error(getErrorMessageFromError(error))
    },
  })
}
